import { Component } from '@angular/core';
import { DataService } from '../shared/services/data-service/data.service';
import { StoreService } from '../shared/services/store-service/store.service';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent {
  constructor(
    public storeService: StoreService,
    private dataService: DataService
  ) {}

  ngOnInit() {
    this.dataService.initSupplierProfiles();
  }
}

